import { FluentProvider, webDarkTheme } from '@fluentui/react-components';
import { ErrorBoundary } from '@worklogix/web-common';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { PlatformApp } from './PlatformApp';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Root element #root not found in index.html.');
}

/**
 * Composition root for the platform-admin console. Providers wrap the app from
 * the outside in:
 *   ErrorBoundary (top-level render-error catch, from web-common)
 *     → FluentProvider (dark Azure-portal theme + Griffel style host)
 *       → BrowserRouter (client-side routing for the console)
 *         → PlatformApp (MSAL AuthProvider + version banner + auth-gated console).
 * FluentProvider must sit above the router so portal chrome (blades, grids,
 * menus) renders inside the themed style context on every route.
 */
createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <FluentProvider theme={webDarkTheme}>
        <BrowserRouter>
          <PlatformApp />
        </BrowserRouter>
      </FluentProvider>
    </ErrorBoundary>
  </StrictMode>
);
